import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MX_STANDARD_ANIMATION_TIMINGS} from '@aviary/store/common/common.types';
import {MatExpansionPanelState} from '@angular/material/expansion';
import {MatIcon} from '@angular/material/icon';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';

@Component({
  selector: 'mx-expandable-card-toggle-button',
  template: `
    <mx-icon-button [customContentTemplate]="toggleIcon"/>

    <ng-template #toggleIcon>
      <mat-icon [@rotate]="{ value: state, params: { collapsedRotation, expandedRotation } }">keyboard_arrow_down</mat-icon>
    </ng-template>
  `,
  animations: [
    trigger('rotate', [
      state('collapsed', style({transform: 'rotate({{collapsedRotation}}deg)'}), {params: {collapsedRotation: 0}}),
      state('expanded', style({transform: 'rotate({{expandedRotation}}deg)'}), {params: {expandedRotation: 180}}),
      transition('collapsed <=> expanded', animate(MX_STANDARD_ANIMATION_TIMINGS)),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, IconButtonComponent]
})
export class ExpandableCardToggleButtonComponent {

  // Note that this component purposely never sets its own state because it needs to react to whatever way a card could be expanded/collapsed.
  @Input() state: MatExpansionPanelState = 'collapsed';

  // OPTIONAL inputs - By default the expansion "arrow" is down when collapsed and up when expanded, but these can be overridden to be any angle.
  @Input() collapsedRotation: number = 0;
  @Input() expandedRotation: number = 180;
}
